<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Thumbs Down" class="d-icon d-icon--thumbs-down" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><g :clip-path="`url(#${uniqueID}a)`"><path fill="currentColor" fill-rule="evenodd" d="M3.25 1.5a.5.5 0 0 0-.48.36l-1.165 4a.5.5 0 0 0 .48.64H5a.5.5 0 0 1 .486.618l-.5 2.06v.002a1.065 1.065 0 0 0 .728 1.275l1.563-3.123A1.503 1.503 0 0 1 8 6.634V1.5H3.25Zm0-1a1.5 1.5 0 0 0-1.44 1.08l-1.165 4a1.5 1.5 0 0 0 1.44 1.92h2.28l-.35 1.44v.001A2.065 2.065 0 0 0 5.993 11.5a.5.5 0 0 0 .453-.276l1.725-3.445v-.002A.5.5 0 0 1 8.62 7.5H10A1.5 1.5 0 0 0 11.5 6V2A1.5 1.5 0 0 0 10 .5H3.25ZM9 1.5v5h1a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5H9Z" clip-rule="evenodd"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconThumbsDown',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
